import APIClient from '@/shared/http/clients/api'

const resourceName = 'lista-inteligente-recorrencia'
const APICore = process.env.APIBaseURLCore

const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/lista-inteligente/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const RecorrenciaListaInteligenteRepository = {
  GetById,
  Create,
  Update
}

export default RecorrenciaListaInteligenteRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/recorrenciaListaInteligente.js